import axios from "axios";
import { invoiceRequestSchema } from "@/schema/RequestInvoiceSchema";
import { z } from "zod";

export const sendInvoiceRequest = async (data: z.infer<typeof invoiceRequestSchema>) => {
    try {
        const response = await axios.post(`${import.meta.env.VITE_API_URL}/email/request-invoice`, data);
        console.log(response);
    } catch (error) {
        console.error(error);
        throw error; // Rethrow the error for handling it in the calling context
    }
};
